const LeadJourneyCardSkeleton = () => {
    return(
        <div className="w-full">
            {/* Outer White Container */}
            <div className="bg-white rounded-2xl md:rounded-3xl shadow-sm p-4 md:p-6 mx-2 md:mx-8 mt-3 md:mt-5">
                {/* Lead ID */}
                <div className="h-4 md:h-5 w-20 md:w-24 bg-gray-200 rounded animate-pulse ml-1"></div>
                
                {/* Company Name */}
                <div className="h-6 md:h-10 w-48 md:w-64 bg-gray-200 rounded animate-pulse mt-2 mb-4 md:mb-5 ml-1"></div>
                
                {/* Badges Row */}
                <div className="flex flex-row gap-2 overflow-x-auto scrollbar-hide pb-2">
                {/* Product Icons */}
                <div className="flex gap-1 md:gap-2 flex-shrink-0">
                    <div className="w-5 h-5 md:w-6 md:h-6 bg-gray-200 rounded animate-pulse"></div>
                    <div className="w-5 h-5 md:w-6 md:h-6 bg-gray-200 rounded animate-pulse"></div>
                    <div className="w-5 h-5 md:w-6 md:h-6 bg-gray-200 rounded animate-pulse"></div>
                </div>
                
                {/* Status Badge */}
                <div className="h-[36px] md:h-10 w-24 md:w-28 bg-gray-200 rounded-full animate-pulse flex-shrink-0"></div>
                
                {/* Lead Status Badge */}
                <div className="h-[36px] md:h-10 w-28 md:w-32 bg-gray-200 rounded-full animate-pulse flex-shrink-0"></div>
                
                {/* Interest Level Badge */}
                <div className="h-[36px] md:h-10 w-20 md:w-24 bg-gray-200 rounded-full animate-pulse flex-shrink-0"></div>
                </div>

                {/* Inner Grey Container */}
                <div className="bg-gray-100 p-3 md:p-4 rounded-2xl md:rounded-3xl border-opacity-20 border-2">
                    {/* Tabs Container */}
                    <div className="flex space-x-4 md:space-x-6 overflow-x-auto scrollbar-hide">
                        <div>
                            <div className="w-full flex flex-col md:flex-row md:justify-between md:items-center gap-3 md:gap-0 mt-3 bg-gray-100 rounded-lg">
                                {/* Left Section: Icon and Text */}
                                <div className="flex items-center">
                                {/* Icon skeleton */}
                                <div className="h-5 w-5 md:h-6 md:w-6 mr-2 md:mr-4 bg-gray-300 rounded animate-pulse flex-shrink-0"></div>
                                
                                {/* Title skeleton */}
                                <div className="h-6 md:h-8 w-36 md:w-48 bg-gray-300 rounded animate-pulse"></div>
                                </div>

                                {/* Right Section: Button placeholder */}
                                <div className="p-0 md:p-8">
                                    <div className="h-10 w-32 bg-gray-300 rounded-lg animate-pulse"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="flex gap-2 md:gap-4 overflow-x-auto md:overflow-x-visible scrollbar-hide pb-2">
                        {[1, 2, 3, 4].map((index) => (
                            <div
                            key={index}
                            className="flex flex-col justify-between min-w-[160px] md:min-w-0 w-full md:flex-1 p-3 md:p-4 rounded-lg shadow-md border-l-4 border-gray-300 bg-white flex-shrink-0 md:flex-shrink"
                            >
                                <div>
                                    {/* Title skeleton */}
                                    <div className="h-6 md:h-7 w-3/4 bg-gray-200 rounded animate-pulse"></div>
                                    
                                    {/* Status label skeleton */}
                                    <div className="h-3 md:h-4 w-1/2 mt-2 bg-gray-200 rounded animate-pulse"></div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
  );
}

const LeadJourneyDetailsSkeleton = () => {
    return(
        <div className="w-full flex justify-between items-center ml-2">
            {/* Inner Grey Container */}
            <div className="p-4 rounded-3xl w-full mr-2">
                {/* Tabs Container */}
                <div className="flex space-x-6 ml-3">
                {[1, 2, 3, 4, 5].map((index) => (
                    <div
                    key={index}
                    className="h-6 w-24 bg-gray-300 rounded animate-pulse mb-3"
                    ></div>
                ))}
                </div>

                {/* Main Content */}
                <div className="w-full bg-white p-7 rounded-3xl shadow-lg">
                {/* Lead Ownership Section Header */}
                <div className="flex justify-between items-start mb-5">
                    <div className="h-8 w-48 bg-gray-200 rounded animate-pulse"></div>
                    <div className="flex space-x-2">
                    <div className="w-12 h-12 bg-gray-200 rounded-full animate-pulse"></div>
                    </div>
                </div>

                {/* Grid Container - Two Column Layout */}
                <div className="grid grid-cols-2 gap-x-5 ml-5">
                    {/* Generate 16 form field skeletons (2 columns x 8 rows) */}
                    {Array.from({ length: 16 }).map((_, index) => (
                    <div key={index} className="flex items-start mt-5">
                        <div className="border-b border-gray-200 pb-2 w-full flex">
                        <div className="w-1/3">
                            <div className="h-5 w-32 bg-gray-200 rounded animate-pulse"></div>
                        </div>
                        <div className="flex-1 flex items-center gap-2">
                            <div className="h-5 flex-1 bg-gray-200 rounded animate-pulse"></div>
                            {index % 3 === 0 && (
                            <div className="w-6 h-6 bg-gray-200 rounded animate-pulse"></div>
                            )}
                        </div>
                        </div>
                    </div>
                    ))}

                    {/* Section Header Skeleton */}
                    <div className="flex items-center mt-5 mb-2 col-span-2">
                    <div className="h-8 w-40 bg-gray-200 rounded animate-pulse -ml-5"></div>
                    </div>

                    {/* Additional form fields after section header */}
                    {Array.from({ length: 12 }).map((_, index) => (
                    <div key={`section2-${index}`} className="flex items-start mt-5">
                        <div className="border-b border-gray-200 pb-2 w-full flex">
                        <div className="w-1/3">
                            <div className="h-5 w-28 bg-gray-200 rounded animate-pulse"></div>
                        </div>
                        <div className="flex-1 flex items-center gap-2">
                            <div className="h-5 flex-1 bg-gray-200 rounded animate-pulse"></div>
                            {index % 4 === 0 && (
                            <div className="w-6 h-6 bg-gray-200 rounded animate-pulse"></div>
                            )}
                        </div>
                        </div>
                    </div>
                    ))}
                </div>

                {/* Referrer Details Section (Optional) */}
                <div className="mt-8">
                    <div className="h-8 w-52 bg-gray-200 rounded animate-pulse mb-5"></div>
                    <div className="grid grid-cols-2 gap-x-5 ml-5">
                    {Array.from({ length: 4 }).map((_, index) => (
                        <div key={`referrer-${index}`} className="flex items-start mt-5">
                        <div className="border-b border-gray-200 pb-2 w-full flex">
                            <div className="w-1/3">
                            <div className="h-5 w-32 bg-gray-200 rounded animate-pulse"></div>
                            </div>
                            <div className="flex-1">
                            <div className="h-5 bg-gray-200 rounded animate-pulse"></div>
                            </div>
                        </div>
                        </div>
                    ))}
                    </div>
                </div>
                </div>
            </div>
        </div>
    )
}

const LeadInfoGatheringSkeleton = () => {
    return(
        <div className='w-full bg-white p-7 rounded-3xl shadow-lg'>
            {/* Section Header */}
            <div className="flex justify-between items-start">
                <div className="flex items-center">
                <div className="h-8 w-64 bg-gray-200 rounded animate-pulse"></div>
                </div>
            </div>

            {/* Grid Container for All Rows */}
            <div className="grid grid-cols-2 gap-x-5 ml-5 text-[#475569]">
                {/* Two column fields */}
                {Array.from({ length: 10 }).map((_, index) => (
                <div key={index} className="flex items-start mt-5">
                    <div className='border-b border-gray-200 pb-2 w-full flex'>
                    <div className="w-1/3">
                        <div className="h-5 w-32 bg-gray-200 rounded animate-pulse"></div>
                    </div>
                    <div className="h-5 w-1/3 bg-gray-200 rounded animate-pulse"></div>
                    </div>
                </div>
                ))}

                {/* Full width fields */}
                {Array.from({ length: 3 }).map((_, index) => (
                <div key={`full-${index}`} className="col-span-2 flex items-start mt-5">
                    <div className='border-b border-gray-200 pb-2 w-full flex'>
                    <div className="w-1/6">
                        <div className="h-5 w-28 bg-gray-200 rounded animate-pulse"></div>
                    </div>
                    <div className="h-5 w-1/3 bg-gray-200 rounded animate-pulse"></div>
                    </div>
                </div>
                ))}

                {/* Insurance Information Section */}
                <div className="flex items-center mt-5 mb-5">
                <div className="h-8 w-56 bg-gray-200 rounded animate-pulse -ml-5"></div>
                </div>
                <br></br>

                {/* Large content area skeleton */}
                <div className="col-span-2 mb-4">
                <div className="p-4 w-full h-64 rounded-lg bg-gray-200 animate-pulse"></div>
                </div>
            </div>
        </div>
    )
}
export {LeadJourneyCardSkeleton, LeadJourneyDetailsSkeleton, LeadInfoGatheringSkeleton}